import {motion} from 'framer-motion'
import {getStatusConfig} from '../types/towel.types'
import {formatLabel} from '../../../../services/formatLabel.ts'

export const TowelsTable = ({data}: any) => {
  return (
    <motion.div
      className='card mt-5'
      initial={{opacity: 0, y: 8}}
      animate={{opacity: 1, y: 0}}
      transition={{duration: 0.35, ease: 'easeOut'}}
    >
      <div className='card-body'>
        <div className='table-responsive'>
          <table className='table align-middle table-row-dashed fs-6 gy-4 min-w-1000px'>
            {' '}
            <thead className='fw-bold text-dark fs-6'>
              {' '}
              <tr>
                <th>Código</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Zona</th>
                <th>Socio</th>
                <th>Operador</th>
                <th>Hora entrega</th>
              </tr>
            </thead>
            <tbody>
              {data.map((t: any) => {
                const tx = t.transactions?.[0]

                return (
                  <tr key={t.id}>
                    <td>{t.codigo}</td>

                    <td>{t.tipo}</td>

                    <td>
                      {(() => {
                        const config = getStatusConfig(t.estado)

                        return (
                          <span className={`badge badge-${config?.badge}`}>
                            {formatLabel(t.estado)}
                          </span>
                        )
                      })()}
                    </td>

                    <td>{t.zone?.nombre}</td>

                    <td>
                      {t.estado === 'en_uso'
                        ? `${tx?.member_nombre || ''} ${tx?.member_apellido || ''}`
                        : '-'}
                    </td>

                    <td>
                      {t.estado === 'en_uso'
                        ? `${tx?.operator?.nombre || ''} ${tx?.operator?.apellido || ''}`
                        : '-'}
                    </td>

                    <td>
                      {t.estado === 'en_uso' && tx?.hora_entrega
                        ? new Date(tx.hora_entrega).toLocaleString()
                        : '-'}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  )
}
